import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useGetSupplierById } from "hooks/useSuppliers";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../constants";

const SupplierDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // Always call the hook, even if id is undefined
  const { data: supplier, isLoading, error } = useGetSupplierById(id || "");
  console.log(supplier);

  // Handle loading and error states
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error fetching supplier details.</div>;

  //Handle Navigate
  const handleNavigate = () => {
    navigate(AppRoutes.SUPPLIERS);
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h2>Supplier Details</h2>
      <p>
        <strong>Name:</strong> {supplier.name}
      </p>
      <p>
        <strong>Phone:</strong> {supplier.phone}
      </p>
      <p>
        <strong>Email:</strong> {supplier.email}
      </p>
      <p>
        <strong>Address:</strong> {supplier.address}
      </p>
      <p>
        <strong>Notes:</strong> {supplier.notes}
      </p>
      <div className=" ">
        <Button onClick={handleNavigate}>Back</Button>
      </div>
    </div>
  );
};

export default SupplierDetail;
